import { useQuery } from "@tanstack/react-query";

import { licenseBannerModel } from "../lib/license";
import { licenseStatusQueryOptions } from "../lib/licenseQuery";

// The app-wide license banner (docs/08-on-prem-readiness.md, "XIV — Offline
// signed licensing"). It surfaces above the routed content whenever the license
// state needs operator attention — nearing expiry, in grace, terminated
// (read-only), or with a pool at 95%/over. Every message but the terminated one
// is warn-only and never implies blocked work. The read is best-effort: a
// failed or absent status simply renders no banner. It shares the periodically
// refetched query definition (lib/licenseQuery.ts) with the settings page so a
// newly reached warn/grace/locked state surfaces without a reload.
export function LicenseBanner() {
  const license = useQuery(licenseStatusQueryOptions());

  const model = licenseBannerModel(license.data);
  if (!model) {
    return null;
  }

  const classes = ["marker-license-banner"];
  if (model.tone === "danger") {
    classes.push("marker-license-banner--danger");
  }

  return (
    <div className={classes.join(" ")} role="status">
      {model.messages.map((message) => (
        <p key={message}>{message}</p>
      ))}
    </div>
  );
}
